import flatpickr from "flatpickr";
import { Estonian } from "flatpickr/dist/l10n/et.js";
import insertDataToForm from "./insertDataToForm";

function initOfferFromToCalendar() {
  const isPresent = document.getElementById("start_date");
  if (!isPresent) {
    return;
  }

  const startInput = document.getElementById("start_date");
  const endInput = document.getElementById("end_date");

  // Retrieve the dates from the data-attribute
  const dateContainer = document.getElementById("dates-container");

  function getParsedAttribute(attributeName) {
    const attributeValue = dateContainer.getAttribute(attributeName);
    return attributeValue ? JSON.parse(attributeValue) : [];
  }

  const offerValidDays = getParsedAttribute("data-offer-valid-dates");
  const offerHighlightedDays = getParsedAttribute(
    "data-offer-highlighted-dates"
  );
  const disabledDays = getParsedAttribute("data-disabled-dates");
  const offerActiveOnlyDays = getParsedAttribute(
    "data-offer-active-only-dates"
  );

  // Function to format a date object to 'Y-m-d'
  function formatDateToYmd(date) {
    const d = new Date(date);
    let month = "" + (d.getMonth() + 1);
    let day = "" + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  function getShowMonths() {
    return window.innerWidth <= 768 ? 1 : 2;
  }

  // Combine all dates from the data attributes into one array
  const allDates = [
    ...offerValidDays,
    ...offerHighlightedDays,
    ...disabledDays,
    ...offerActiveOnlyDays,
  ];

  // Remove duplicates
  const uniqueDates = Array.from(new Set(allDates));

  // Get today's date in Y-m-d format for comparison
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Ensure no time component for accurate comparison

  // Parse dates into Date objects, filter out past dates, and find the earliest date
  let futureDates = uniqueDates
    .map((dateStr) => new Date(dateStr))
    .filter((d) => !isNaN(d.getTime()) && d >= today); // Exclude invalid and past dates

  let earliestDate = null;
  if (futureDates.length > 0) {
    earliestDate = new Date(Math.min.apply(null, futureDates));
  }

  const commonOptions = {
    enableTime: false,
    showMonths: getShowMonths(),
    dateFormat: "d.m.Y",
    inline: true,
    locale: Estonian,
    // Set defaultDate to earliestDate or "today"
    defaultDate: earliestDate || "today",
    onDayCreate: function (dObj, dStr, fp, dayElem) {
      const dateStr = formatDateToYmd(dayElem.dateObj);

      if (
        offerActiveOnlyDays.length > 0 &&
        !offerActiveOnlyDays.includes(dateStr)
      ) {
        dayElem.classList.add("disabled-date");
        dayElem.classList.add("flatpickr-disabled");
        dayElem.removeAttribute("tabindex");
      } else {
        if (offerValidDays.includes(dateStr)) {
          dayElem.classList.add("offer-valid-day");
        }

        if (offerHighlightedDays.includes(dateStr)) {
          dayElem.classList.add("offer-highlighted-day");
        }

        if (disabledDays.includes(dateStr)) {
          dayElem.classList.add("disabled-date");
          dayElem.classList.add("flatpickr-disabled");
          dayElem.removeAttribute("tabindex");
        }
      }
    },
  };

  const endCalendar = flatpickr(endInput, {
    ...commonOptions,
    mode: "range",
    minDate: "today",
    onChange: function (selectedDates, dateStr, instance) {
      const infobox = document.querySelector(".end-date-info");
      const trigger = document.getElementById("calendar-to");

      if (selectedDates.length === 2) {
        const endDate = instance.formatDate(selectedDates[1], "d.m.Y");
        trigger.innerHTML = endDate;
        infobox.innerHTML = endDate;
        insertDataToForm();
      }

      setTimeout(() => {
        trigger.click();
      }, 100);
    },
  });

  const startCalendar = flatpickr(startInput, {
    ...commonOptions,
    minDate: "today",
    onChange: function (selectedDates, dateStr, instance) {
      endCalendar.set("minDate", dateStr);
      endCalendar.setDate([dateStr, null]);

      const infobox = document.querySelector(".start-date-info");
      const trigger = document.getElementById("calendar-from");
      trigger.innerHTML = dateStr;
      infobox.innerHTML = dateStr;
      insertDataToForm();

      setTimeout(() => {
        trigger.click();
      }, 100);
    },
  });

  window.addEventListener("resize", () => {
    const newShowMonths = getShowMonths();
    startCalendar.set("showMonths", newShowMonths);
    endCalendar.set("showMonths", newShowMonths);
  });
}

export { initOfferFromToCalendar };
